module.exports = __webpack_public_path__ + "img/dpsy-icon-rd.a9d816b3.png";